import {
  login,
  logout,
  resetPassword,
  sendResetLink,
  sendInviteLink,
  signInWithGoogle,
  getProfile,
  getLoggedInUserDetails
} from "@/apis/auth/index";
import router from "@/router/index";
import store from "../index";
import { clearAppTheme } from "@/utils/taskDashboardThemes";

function finishUpLogout(commit) {
  commit('removeUnloadListener', {}, { root: true })
  commit("logoutUser");
}

export const authModule = {
  namespaced: true,
  state: () => ({
    token: null,
    userDetails: {
      email: "",
      password: "",
      key: ""
    },
    role: "",
    navAvatar: "",
    fullName: "",
    firstName: "",
    lastName: "",
    profileUserId: ""
  }),
  mutations: {
    loginUser(state, payload) {
      state.profileUserId = payload.defaultProfile.id;
      state.token = payload.key;
      state.role = payload.role;
      localStorage.setItem("user-token", state.token);
      // Persisted so the router's synchronous beforeEach can gate Owner
      // routes on a hard refresh, before the store is rehydrated.
      localStorage.setItem("user-role", state.role);
    },
    logoutUser(state) {
      localStorage.clear();
      clearAppTheme();
      state.token = null;
    },
    setAuthenticated(state) {
      state.isAuthenticated = true;
    },
    resetPassword(state) {
      console.log(state);
    },
    sendResetLink(state) {
      console.log(state);
    },
    sendInviteLink(state) {
      console.log(state);
    },
    signInWithGoogle(state, payload) {
      state.token = payload.key;
      // state.roleId = payload.roleId;
      // localStorage.setItem("roleId", state.roleId);
      localStorage.setItem("user-token", state.token);
    },
    getProfile(state, payload) {
      state.firstName = payload.firstName;
      state.lastName = payload.lastName;
      state.email = payload.email;
    },
    getUserDetails(state, payload) {
      state.role = payload.defaultProfile.role.name;
      state.profileUserId = payload.defaultProfile.id;
      state.navAvatar = payload.avatarThumbnail;
      state.fullName = `${payload.firstName} ${payload.lastName}`;
      localStorage.setItem("user-role", state.role);
    }
  },
  actions: {
    actionAuthenticateUser({ commit }, payload) {
      return login(payload).then(res => {
        commit("loginUser", res.data);
        return res;
      });
    },
    async actionLogoutUser({ commit }) {
      if (store.state.isUnloadListenerAttached) {
        const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
        if (answer) {
          try {
            await logout()
            finishUpLogout(commit)
          } catch(e) {
            if (e.response.data.detail.includes('Please pause running')) {
              throw e
            } else {
              router.push({
                name: 'Login'
              })
              finishUpLogout(commit)
            }
          } 
        } else {
          console.log('throwing error')
          throw new Error('logout cancelled')
        }
      } else {
        try {
          await logout()
          finishUpLogout(commit)
        } catch(e) {
          if (e.response.data.detail.includes('Please pause running')) {
            throw e
          } else {
            router.push({
              name: 'Login'
            })
            finishUpLogout(commit)
          }
        } 
      }
    },
    resetPassword({ commit }, payload) {
      return resetPassword(payload).then(res => {
        commit("resetPassword", res);
        return res;
      });
    },
    sendResetLink({ commit }, payload) {
      return sendResetLink(payload).then(res => {
        commit("sendResetLink", res);
        return res;
      });
    },
    actionSendInviteLink({ commit }, payload) {
      return sendInviteLink(payload).then(res => {
        commit("sendInviteLink", res);
        return res;
      });
    },
    signInWithGoogle({ commit }, payload) {
      return signInWithGoogle(payload).then(res => {
        commit("signInWithGoogle", res.data);
        return res;
      });
    },
    getProfile({ commit }) {
      return getProfile().then(res => {
        commit("getProfile", res.data);
        return res.data;
      });
    },
    actionGetUserDetails({ commit }) {
      return getLoggedInUserDetails().then(res => {
        commit("getUserDetails", res.data);
        return res.data;
      });
    }
    // setAuth({ commit }) {
    //   console.log("agiuehejioagnji");
    //   commit("setAuthenticated");
    // },
  }
};
